import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';

import { FormSelectionListComponent } from './form-selection-list.component';

export const imports: NgModule['imports'] = [
  FlexLayoutModule,
  FormErrorModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatListModule,
  MatRadioModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormSelectionListComponent],
  imports: [...imports, CommonModule],
  exports: [FormSelectionListComponent],
})
export class FormSelectionListModule {}
